import { Fragment, memo } from "react";

import { Transition } from "@headlessui/react";

import { CartDrawerView } from "@cart/CartDrawer/CartDrawer.view";

type CartDrawerAnimationProps = Record<
  "enter" | "enterFrom" | "enterTo" | "leave" | "leaveFrom" | "leaveTo",
  string
>;

type Props = CartDrawerAnimationProps;

const CartDrawerBase = ({ ...cartDrawerAnimationProps }: Props) => {
  return (
    <Transition.Child as={Fragment} {...cartDrawerAnimationProps}>
      <CartDrawerView />
    </Transition.Child>
  );
};

export const CartDrawer = memo(CartDrawerBase);
